<script setup lang="ts">
  import { computed, onErrorCaptured, reactive, ref, watch } from 'vue';
  import { useErrorStore } from '@/stores/error.ts';
  import { ApiFlexError } from '@/services/api/api-error.ts';
  import { useRoute, useRouter } from 'vue-router';

  const router = useRouter();
  const route = useRoute();
  const errorStore = useErrorStore();
  const isShowDetail = ref(false);

  const defaults = () => ({
    name: '',
    message: '',
    detail: null,
    // stack: '',
  });

  const errorInfo = reactive(defaults());

  function setError(err: Error) {
    if (err instanceof ApiFlexError && err.value.resultCode == 401) {
      localStorage.setItem('redirect', route.fullPath);
      router.push({
        name: 'Login',
      });
      return;
    }

    errorInfo.name = err.name;
    errorInfo.message = err.message;
    // errorInfo.stack = err.stack ? err.stack.split('\n').join('') : '';
    errorInfo.detail = (err as any).detail || null;
  }

  onErrorCaptured((err) => {
    setError(err);
  });

  watch(
    () => errorStore.error,
    (newErr) => {
      if (newErr instanceof Error) {
        setError(newErr);
        return;
      }
      if (newErr) {
        const unknownErr = new Error();
        unknownErr.name = 'Unknown Error';
        unknownErr.message = '알 수 없는 오류';
        setError(unknownErr);
        return;
      }
      errorInfo.name = '';
      errorInfo.message = '';
      errorInfo.detail = null;
    },
    {
      immediate: true,
    }
  );

  const hasError = computed(
    () => Boolean(errorInfo.name) || Boolean(errorInfo.message)
  );

  const detail = computed(() => {
    const detail = errorInfo.detail ? errorInfo.detail : errorInfo;
    return JSON.stringify(detail, null, 2);
  });

  function rescue() {
    window.location.reload();
  }

  function markResolved() {
    isShowDetail.value = false;
    Object.assign(errorInfo, defaults());
    errorStore.setError(undefined);
  }
</script>

<template>
  <slot />

  <AppModal
    id="error_display"
    :is-visible="hasError">
    <div class="flex items-center justify-center">
      <div class="card card-compact w-full max-w-lg bg-base-100">
        <figure class="px-14 pt-2">
          <img
            src="../../assets/images/server-down.svg"
            alt="Shoes"
            class="rounded-xl" />
        </figure>
        <div class="card-body">
          <div class="chat chat-start">
            <div class="chat-bubble">죄송합니다! 😥</div>
          </div>
          <div class="chat chat-start">
            <div class="chat-bubble chat-bubble-error font-bold">
              {{
                errorInfo?.detail
                  ? (errorInfo?.detail as any).message
                  : errorInfo.message
              }}
            </div>
          </div>

          <div
            v-if="isShowDetail"
            class="mt-2 bg-base-200 rounded-xl px-3 py-3 text-xs">
            <!-- prettier-ignore -->
            <pre class="w-full h-max max-w-80 max-h-72 whitespace-pre-wrap break-all overflow-y-auto">{{ detail }}</pre>
          </div>

          <div class="card-actions mt-6 justify-center join gap-0">
            <button
              class="btn btn-error btn-outline join-item"
              @click="rescue">
              새로고침
            </button>
            <button
              class="btn btn-neutral btn-outline join-item"
              @click="isShowDetail = !isShowDetail">
              상세 내용
            </button>
            <button
              class="btn btn-primary join-item"
              @click="markResolved">
              그냥 닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  </AppModal>
</template>
